<div class="modal-dialog">
  <div class="modal-content">
    <div class="modal-header">Delete files</div>

    <div class="modal-body">
      <p class="mb-3">You are about to delete the following files</p>
      <div class="files-table-scroll">
        <table class="cl-table-data cl-table-data-light">
          <thead>
            <tr>
              <th class="cl-table-head">
                Type
              </th>
              <th class="cl-table-head">
                File or folder name
              </th>
              <th class="cl-table-head">
                <div>
                  Last Modified
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            @for (item of items; track item) {
              <tr>
                <td>
                  @if (item.__typename === 'File') {
                    <i class="fas fa-file"></i>
                  }
                  @if (item.__typename === 'Folder') {
                    <i class="fas fa-folder"></i>
                  }
                </td>
                <td>
                  {{ item.name }}
                </td>
                <td class="cl-td-time">
                  @if (item.__typename === 'File') {
                    <app-date [value]="item.last_modified" />
                  }
                </td>
              </tr>
              }
            </tbody>
          </table>
        </div>

      @if (needsKeyword) {
        <!-- castlabs-ui ClModalConfirm: type the keyword to enable the destructive action. -->
        <div class="cl-form cl-spacing-small">
          <label for="confirm-keyword" class="form-label">To confirm, type <code>{{ confirmKeyword }}</code> into this field:</label>
          <input id="confirm-keyword" type="text" class="form-control text-center it-confirm" autocomplete="off"
                 [value]="confirmText()" (input)="confirmText.set($any($event.target).value)"
                 (keyup.enter)="confirmed && footer.button.performAction()">
        </div>
      }
      <!-- Destructive action: the warning sits directly above the button (styleguide). -->
      <p class="alert cl-alert-warning" role="alert" data-delete-warning>The selected files and folders will be deleted. Deleted files stay listed (uncheck "Hide deleted files")
        and can be brought back with "Restore files".</p>
      </div>
      <div class="modal-footer">
        <app-form-footer #footer="formFooter" [label]="'Delete ' + items.length + (items.length === 1 ? ' item' : ' items')"
                         [disabled]="!confirmed" (action)="performDelete($event)">
          <button footerStart type="button" class="btn cl-color-secondary it-cancel" (click)="dialogRef.close()"><span>Cancel</span></button>
        </app-form-footer>
      </div>
      </div>
    </div>
